<h2 mat-dialog-title>Detalle Persona</h2>
<mat-dialog-content class="mat-typography">

  <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h3 class="titulo-solicitud">Información Básica</h3>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="contenedor-form" *ngIf="loadingPersona">
          <mat-spinner
            [diameter]="100"
            style="margin:0 auto; top:15px;"
          ></mat-spinner>
        </div>



  <div style="text-align: center; margin-bottom: 20px;" *ngIf="!loadingPersona">
  <form [formGroup]="personaGroup" (ngSubmit)="submitForm()">
    <div class="row">
      <div class="col s12 m4 l4">
          <mat-form-field class="example-full-width" >
          <input matInput readonly placeholder="NÚMERO DOCUMENTO" formControlName="NroDocId" type="text">
          </mat-form-field>
      </div>
      <div class="col s12 m4 l4">
          <mat-form-field class="example-full-width" >
          <input matInput placeholder="NOMBRE" formControlName="Nombre" type="text">
          </mat-form-field>
      </div>
      <div class="col s12 m4 l4">
          <mat-form-field class="example-full-width" >
          <input matInput placeholder="APELLIDO" formControlName="Apellido" type="text">
          </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col s12 m4 l4">
          <select style="margin-top: 15px;" formControlName="IdTpoIdenti">
            <option value="" disabled selected>TIPO DOCUMENTO</option>
            <option *ngFor="let opt of tipoDocumentosSelect" [value]="opt.Id">
              {{opt.Valor}}
            </option>
          </select>
      </div>
      <div class="col s12 m4 l4">
          <mat-form-field class="example-full-width" >
              <input matInput [matDatepicker]="picker1" readonly placeholder="FECHA NACIMIENTO" formControlName="FechaNac">
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
      </div>
      <div class="col s12 m4 l4">
          <mat-form-field class="example-full-width" >
          <input matInput placeholder="TELÉFONO" formControlName="Telefono" type="text">
          </mat-form-field>
      </div>
    </div>
    <button mat-raised-button type="submit" color="accent" [disabled]="!personaGroup.valid">Actualizar</button>
  </form>
  </div>

</mat-expansion-panel>
<br>
<!--DIRECCIONES-->
<mat-expansion-panel expanded="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h3 class="titulo-solicitud">Información Direcciones</h3>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="contenedor-form" *ngIf="loadingDetalle">
      <mat-spinner
        [diameter]="100"
        style="margin:0 auto; top:15px;"
      ></mat-spinner>
    </div>

      <div class="row">
        <div class="col s12 m12 l12" align="end">
            <!--<span class=oscuro>Agregar Dirección</span>-->
            <button mat-fab (click)="crearDireccion();">
                <mat-icon>add</mat-icon>
            </button>
        </div>
      </div>
    <!--CREAR DIRECCIONES-->
    <div *ngIf="creaDireccion">
        <div class="contenedor-form" *ngIf="items">
          <!--<app-dynamic-form #resetForm [items]="items" (dataFormulario)="dataFormulario($event);" [descripcion]="descripcion" [origenParent]="origenParent" [parametrosDestino]="parametrosDestino" [procedimientoDestino]="procedimientoDestino"></app-dynamic-form>-->
          
          <form [formGroup]="direccionGroup" (ngSubmit)="nuevaDireccion()">
            <div class="row">
              <div class="col s12 m4 l4">
                  <mat-form-field class="example-full-width" >
                  <input matInput placeholder="NOMBRE DIRECCION" formControlName="nombreDireccion" type="text">
                  </mat-form-field>
              </div>
              <div class="col s12 m4 l4">
                  <mat-form-field class="example-full-width" >
                  <input matInput placeholder="TELEFONO" type="number" formControlName="telefono" type="text">
                  </mat-form-field>
              </div>
              <div class="col s12 m4 l4">
                  <mat-form-field class="example-full-width" >
                  <input matInput placeholder="TELEFONO 2" type="number" formControlName="telefono2" type="text">
                  </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col s12 m4 l4">
                  <select style="margin-top: 15px;" formControlName="departamento"  (change)="getCiudades($event)">
                    <option value="" disabled selected>DEPARTAMENTO</option>
                    <option *ngFor="let opt of departamentosDireccion" [value]="opt.id">
                      {{opt.valor}}
                    </option>
                  </select>
              </div>
              <div class="col s12 m4 l4">
                <select style="margin-top: 15px;" formControlName="ciudad">
                  <option value="" disabled selected>CIUDAD</option>
                  <option *ngFor="let opt of ciudadesDireccion" [value]="opt.id">
                    {{opt.valor}}
                  </option>
                </select>
              </div>
              <div class="col s12 m4 l4">
                  <mat-form-field class="example-full-width" >
                  <input matInput placeholder="DIRECCION" formControlName="direccion" type="text">
                  </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col s12 m4 l4">
                <mat-form-field class="example-full-width" >
                <input matInput placeholder="OBSERVACION" formControlName="observacion" type="text">
                </mat-form-field>
            </div>          
            </div>
            <button mat-raised-button type="submit" color="accent" [disabled]="!direccionGroup.valid">Actualizar</button>
          </form>

        
        </div>
        <div class="contenedor-form" *ngIf="!items">
          <mat-spinner [diameter]="100" style="margin:0 auto; top:15px;"></mat-spinner>
        </div>
      </div>
    <!--FIN CREAR DIRECCIONES-->

    <app-modificar-direccion-persona *ngIf="modificaDireccion" [dataModificaDireccion]="dataModificaDireccion" (propagar)="procesaPropagarDireccion($event)"></app-modificar-direccion-persona>

    <mat-list>
        <mat-list-item *ngFor="let direccion of direcciones">
          <h4 mat-line><span class="oscuro">Nombre Dirección:</span> {{direccion.NombreDireccion}}</h4>
          <h4 mat-line><span class="oscuro">Dirección:</span> {{direccion.Direccion}} <span class="oscuro">Ciudad:</span> {{direccion.Descripcion}}</h4>
          <p mat-line> <span class="oscuro">Teléfono:</span> {{direccion.Telefono}} &nbsp;<span class="oscuro">Teléfono:</span>{{direccion.Telefono2}} </p>
          <p mat-line> <span class="oscuro">Observación:</span> {{direccion.Observacion}}</p>
          <button mat-icon-button (click)="editarDireccion(direccion);">
              <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button (click)="eliminarDireccion(direccion);">
              <mat-icon>delete</mat-icon>
            </button>
            <mat-divider style="width:98%;"></mat-divider>
        </mat-list-item>
      </mat-list>


    </mat-expansion-panel>
<br><!--USUARIOS-->
<mat-expansion-panel expanded="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h3 class="titulo-solicitud">Información Usuarios</h3>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="contenedor-form" *ngIf="loadingDetalle">
      <mat-spinner
        [diameter]="100"
        style="margin:0 auto; top:15px;"
      ></mat-spinner>
    </div>



    <app-modificar-usuario-persona *ngIf="modificaUsuario" [dataModificaUsuario]="dataModificaUsuario" (propagar)="procesaPropagar($event)"></app-modificar-usuario-persona>

    <mat-list>
        <mat-list-item *ngFor="let usuario of usuarios">
          <h4 mat-line><span class="oscuro">Usuario:</span> {{usuario.Usuario}} <span class="oscuro">Tipo Usuario:</span> {{usuario.DescripcionTipo}}</h4>
          <p mat-line> <span class="oscuro">Observación:</span> {{usuario.Descripcion}} </p>
          <button mat-icon-button (click)="editarUsuario(usuario);">
              <mat-icon>edit</mat-icon>
            </button>
          <button mat-icon-button (click)="eliminarUsuario(usuario);">
              <mat-icon>delete</mat-icon>
            </button>
            <mat-divider style="width:98%;"></mat-divider>
        </mat-list-item>
      </mat-list>


    </mat-expansion-panel>

<br>

</mat-dialog-content>

<br>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="dataModified" cdkFocusInitial>Cerrar</button>
  <!--<button mat-button (click)="ActualizarPersona();" cdkFocusInitial>Actualizar</button>-->
</mat-dialog-actions>
